// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".requiredIdentification[data-v-276c561a]{color:red;position:absolute;left:2px;top:2px}.add-one[data-v-276c561a]{margin-top:16px}.seat-num[data-v-276c561a]{width:100%}", ""]);
// Exports
module.exports = exports;
